export const isNumber = (input: string): boolean => RegExp(/\d/, 'gi').test(input);
